import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {fetchCategories} from "../../../redux/actions/categoryActions"
export default function SectionTwo() {
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const [scrollIndex, setScrollIndex] = useState(0);
  const [stopScroll, setStopScroll] = useState(false);
  const navigate=useNavigate();

  const dispatch=useDispatch();

  const {categories=[]}=useSelector((state)=>state.categoryState);

  useEffect(()=>{
    if(categories.length==0){
      dispatch(fetchCategories());
    }
  },[dispatch,categories.length]);

  useEffect(() => {
    const container = scrollRef.current;

    const scrollNext = () => {
      if (!container || stopScroll) return;

      const itemWidth = container.firstChild?.offsetWidth || 120;
      const totalVisible = Math.floor(container.offsetWidth / itemWidth);
      const totalScrollable = categories.length - totalVisible;

      setScrollIndex((prevIndex) => {
        const newIndex = prevIndex >= totalScrollable ? 0 : prevIndex + 1;

        container.scrollTo({
          left: newIndex * itemWidth,
          behavior: "smooth",
        });

        return newIndex;
      });
    };

    intervalRef.current = setInterval(scrollNext, 2500);

    return () => clearInterval(intervalRef.current);
  }, [stopScroll]);

  const handleCategoryClick = (cat) => {
    setStopScroll(true);
    navigate("/productpage", { state: { category: cat.id } }); 
  };

  return (
    <div className="py-8 px-4 md:px-8 xl:px-10">
      <h2 className="text-xl md:text-2xl xl:text-3xl font-semibold text-center mb-3 md:mb-6">
        Explore by Categories
      </h2>

      <div className="p-3 w-full flex justify-center rounded-xl border-2 border-[#A63F40]">
        <div
          ref={scrollRef}
          className="flex overflow-x-hidden scroll-smooth"
        >
          {categories.map((cat, idx) => (
            <div
              key={idx}
              onClick={() => handleCategoryClick(cat)}
              className="flex-shrink-0 py-2 flex flex-col items-center justify-center transition min-w-[100px] md:min-w-[120px] xl:min-w-[160px] cursor-pointer hover:scale-105 hover:shadow-xl hover:bg-gray-50 hover:rounded-xl overflow-y-hidden"
            >
              <img src={cat.image} alt="categoryImage" className="w-20 h-20 rounded-2xl"/>
              <p className="text-sm md:text-base xl:text-lg capitalize text-center text-zinc-800 font-medium">
                {cat.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
